// @flow

// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'

// Utils
import traverse from 'fc-utils/traverse'

// Selectors
import { seasons$ } from 'fc-seasons'

// Types
import type { SeasonsById } from 'fc-model-seasons/types'

// Model Properties
import { PROP_SEASON_ID } from 'fc-model-seasons'

// Local Selectors
export const selectedSeasonId$ = traverse(['mapModule', 'selectedSeasonId'])

// Exports
export default createSelector([seasons$, selectedSeasonId$], (seasons: SeasonsById, seasonId: number): ?number => {
  const isValidSeasonId = _find(seasons, { [PROP_SEASON_ID]: seasonId })

  return isValidSeasonId ? seasonId : null
})
